import { Component, EventEmitter, Input, Output } from '@angular/core';
import { JoiResource, ResourceContact } from 'globals/store/resources.data';
import { MatDialog } from '@angular/material/dialog';
import { openConfirmDeleteGetResult } from '../../components/dialog.confirmDelete.component';
import { PhotoComponent } from 'src/app/components/photo';
import { MatMenuModule } from '@angular/material/menu';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { SmallButtonComponent } from 'src/app/components/buttons/small-button.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'resource-contact-card',
    template: `
<ng-container *ngIf="{ name: contact.firstName || contact.lastName ?  (contact.firstName || '') + ' ' + (contact.lastName || '') : 'Unnamed Contact' } as vars">
  <photo [size]="36" [data]="{title: vars.name, photoURL: contact.photoURL}"></photo>
  <div class="titles">
    <div class="subtitle" *ngIf="!!vars.name">{{ vars.name }}</div>
    <div class="greyTitle" *ngIf="!!contact.role">{{ contact.role }}</div>
  </div>
  <div style="flex:1"></div>
  <div class="right" *ngIf="{ isPrimary: resource.primaryContactId === contact.id } as primary">
    <small-button *ngIf="primary.isPrimary">PRIMARY CONTACT</small-button>
    <div class="dot-menu-holder" *ngIf="!readOnly" [matMenuTriggerFor]="dotMenu" (click)="$event.stopPropagation()">
      <icon class="dots" matIcon="more_vert"></icon>
    </div>
    <mat-menu #dotMenu="matMenu" xPosition="before">
      <button mat-menu-item (click)="dotOption.emit('edit')">Edit</button>
      <button mat-menu-item (click)="delete($event)">Delete</button>
      <button mat-menu-item *ngIf="!primary.isPrimary" (click)="dotOption.emit('primarify')">Make primary contact</button>
    </mat-menu>
  </div>
</ng-container>
`,
    styleUrls: ['./resource-contact-card.scss'],
    standalone: true,
    imports: [PhotoComponent, MatMenuModule, IconComponent, SmallButtonComponent, CommonModule],
})
export class ResourceContactCardComponent {
  @Input() resource: JoiResource
  @Input() contact: ResourceContact
  @Input() readOnly
  @Output() dotOption: EventEmitter<'edit' | 'delete' | 'primarify'> = new EventEmitter()
  
  constructor(private dialog: MatDialog) {}

  async delete(event) {
    const data = {
      title: "Delete contact",
      para: "This action cannot be undone",
      dialog: this.dialog,
      rect: event.target.getBoundingClientRect(),
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.dotOption.emit('delete')
  }
 
}